import { render, staticRenderFns } from "./VDataTableWithAutoScroll.vue?vue&type=template&id=be72f492&"
import script from "./VDataTableWithAutoScroll.vue?vue&type=script&lang=js&"
export * from "./VDataTableWithAutoScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports